import { createAction, props } from '@ngrx/store';
import { NextStep } from '@shared/models/next-step';

export const createNextStep = createAction('[Next Steps] Create Next Step', props<{ nextStep: Partial<NextStep> }>());

export const createNextStepSuccess = createAction(
  '[Next Steps] Create Next Step Success',
  props<{ nextStep: NextStep }>(),
);

export const createNextStepFailure = createAction('[Next Steps] Create Next Step Failure', props<{ error: any }>());
